import state from "./cartState";
import getters from "./cartGetters";
import mutations from "./cartMutations";
import actions from "./cartActions";

export default {
	state,
	getters,
	actions,
	mutations
};
